import { render, staticRenderFns } from "./PaymentGatewayItem.vue?vue&type=template&id=a48939ca&scoped=true&"
import script from "./PaymentGatewayItem.vue?vue&type=script&lang=js&"
export * from "./PaymentGatewayItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48939ca",
  null
  
)

export default component.exports